import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";

const ArtistRidersDropdown = (props: DropdownProps<server.dto.ArtistRider>) => {
  return <BaseReactSelectDropdown
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    options={props.options}
    getLabel={rider => rider.title}
    getValue={rider => rider.artistRiderId}
    excludeKeys={props.excludeKeys}
    config={{
      placeholder: RESX.GeneralLabels.NoChoiceMade,
      isClearable: true,
      ...props.config
    }}
  />;
};

export default ArtistRidersDropdown;